export default "__VITE_ASSET__DuV$jE4M__"